import React from 'react'

export const ArrowNextCarousel = ({
  className = 'text-white'
}: {
  className?: string
}) => {
  return (
    <svg
      width='6'
      height='10'
      viewBox='0 0 6 10'
      fill='none'
      className={className}
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M5.99219 4.92027C5.99219 4.78399 5.94311 4.66398 5.83951 4.56041L1.51544 0.334495C1.42274 0.236315 1.30279 0.187226 1.16101 0.187226C0.87745 0.187226 0.659361 0.399917 0.659361 0.683475C0.659361 0.825207 0.719339 0.945209 0.806584 1.0379L4.77621 4.92027L0.806583 8.80268C0.719339 8.89538 0.65936 9.02079 0.65936 9.15711C0.65936 9.44066 0.877449 9.65332 1.16101 9.65332C1.30279 9.65332 1.42274 9.60424 1.51544 9.51155L5.83951 5.28017C5.94311 5.18202 5.99219 5.0566 5.99219 4.92027Z'
        fill='currentColor'
      />
    </svg>
  )
}
